// extracted by mini-css-extract-plugin
module.exports = {"img":"services_img_1uflJ","imgweb":"services_imgweb_3TT0_"};